import React,{useState} from 'react';
import {Link,useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trackButtonClick } from '../utils/tracking';
const {FiMenu,FiX}=FiIcons;

const Header=()=> {
  const [isMenuOpen,setIsMenuOpen]=useState(false);
  const location=useLocation();
  const navigation=[
    {name: 'Home',href: '/'},
    {name: 'Compare Plans',href: '/compare'},
    {name: 'Blog',href: '/blog'}
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-lg">
      {/* Row 1 - Centered Logos */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center py-6">
          <div className="flex items-center space-x-4">
            <img
              src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png"
              alt="Burbank Insurance Services"
              className="h-12 w-auto"
            />
            <span className="text-blue-600 font-bold text-2xl">+</span>
            <img
              src="https://cdn1.sharemyimage.com/smi/2025/09/13/nw-logo.png"
              alt="Nationwide Insurance"
              className="h-10 w-auto"
            />
          </div>
        </div>
      </div>

      {/* Row 2 - Full Width Blue Banner */}
      <div className="bg-blue-600 text-white py-3 w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-center text-center">
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-8">
              <div className="flex items-center">
                <span className="font-semibold text-sm sm:text-base">America's #1 Pet Insurer</span>
              </div>
              <div className="hidden sm:block text-blue-200">•</div>
              <div className="flex items-center">
                <span className="font-semibold text-sm sm:text-base">100% Satisfaction Guaranteed</span>
              </div>
              <div className="hidden sm:block text-blue-200">•</div>
              <div className="flex items-center">
                <span className="font-semibold text-sm sm:text-base">No Cancellation Fees</span>
              </div>
              <div className="hidden sm:block text-blue-200">•</div>
              <div className="flex items-center">
                <span className="font-semibold text-sm sm:text-base">Easy Online Claims</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Row 3 - Navigation & CTA */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 border-b border-gray-100">
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === item.href
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Mobile Navigation Placeholder */}
          <div className="md:hidden"></div>

          {/* Get Quote Button */}
          <div className="flex items-center">
            <a
              href="https://partnersolutions.nationwide.com/pet/burbankinsuranceservices"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackButtonClick('Header Get Instant Quote')}
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors"
            >
              Get Instant Quote
            </a>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden ml-4 p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100"
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden py-4 border-b border-gray-200 bg-white"
          >
            <div className="flex flex-col space-y-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-3 py-2 rounded-md text-sm font-medium ${
                    location.pathname === item.href
                      ? 'text-blue-600 bg-blue-50'
                      : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;